
 export const LABELS_EN = {
     "base": {
         "createReportHelper": "To create a report, select the parameters...",
         "date": "Date",
         "passengerCountEstimate": "Estimated passenger count (test counting), may be low on crowded buses",
         "passengerCounting": "Passenger counting (test)",
         "passengerCountingShort": "Passengers",
         "cameraCounterShort": "Cameras",
         "zoneRecordingModeShort": "Stop video",
         "cameraPositionShort": "Position",
         "isActiveShort": "Photos",
         "passengerCountingHint": "Daytime photos of this camera (07–19) are sent to the test passenger counting. Needs photo capture on. Takes effect within 10 minutes.",
         "theme": "Theme",
         "enabledAutoTracking": "Enabled auto-tracking",
         "statistic": "Statistics",
         "routeName": "Route Name",
         "latitudeAndLongitude": "Latitude/Longitude",
         "address": "Address",
         "points": "Stops",
         "routeInfo": "Route Information",
         "hide": "Hide",
         "zoomMapForShowCorrectionPoints": "Zoom in to display correction points",
         "by": "By",
         "point": "Stop",
         "edited": "ed.",
         "editedAt": "Edited",
         "fixError": "Fix Errors",
         "noAccessMessage": "No access...",
         "select": "Select",
         "selectPoint": "Select stop",
         "employee": "Employee",
         "selectPoints": "Select stops",
         "savePoint": "Save stop",
         "cancel": "Cancel",
         "entryRadius": "Entry Radius",
         "pointCount": "Number of stops",
         "tasksCount": "Number of tasks",
         "dateTimeStart": "Start Date",
         "dateTimeEnd": "End Date",
         "notAvailableForMobile": "This functionality is not available on mobile devices",
         "hidePoint": "Hide stop",
         "addPoint": "Add stop",
         "singleVoyage": "Single voyage",
         "routeSettings": "Route SettingsTrackAdvancedGroup",
         "showAdditionalExportInfo": "Export additional report information",
         "yearDate": "Year",
         "reportSubmissionDate": "Report Submission Date",
         "exportSettings": "Export SettingsTrackAdvancedGroup",
         "organizationName": "Organization Name",
         "withoutParent": "Without parent",
         "table": "Table",
         "showLineRoute": "Display route line",
         "tree": "Tree",
         "showOnlyTarget": "Show only selected",
         "parentGroup": "Parent group",
         "additionNumber": "Addition No.",
         "theReportIsGenerated": "The report is generated",
         "toTheContract": "To the contract",
         "navigation": "Navigation",
         "signature": "Signature",
         "fullNameAgentGIS": "LLC \"Ukrainian Geoinformation Systems\"",
         "odometerKM": "Speed, km/h",
         "course": "Course",
         "routes": "Routes",
         "voyageCount": "Number of voyages",
         "geoZone": "Geo zone",
         "pointInfo": "Stop Information",
         "totalPoints": "Total stops",
         "skippedPoints": "Skipped stops",
         "visitedPoints": "Visited stops",
         "onAllRoutes": "On all routes",
         "selectDevice": "Select vehicle",
         "selectGroups": "Select Groups",
         "nothingGroups": "No groups found",
         "nothingDevice": "No vehicles found",
         "hasClusterGroups": "Group vehicles that are close to each other",
         "geoZoneType": "Geo zone type",
         "trackName": "Track",
         "toggleShowQueryParams": "Show/hide track parameters",
         "notFoundByQueryData": "Nothing found for these parameters...",
         "layer": "Layer",
         "id": "ID",
         "autoTracking": "Auto-tracking",
         "lastLocation": "Last Location",
         "selectedGroups": "Select groups",
         "code": "Code",
         "successSaveMessage": "You have successfully saved the data!",
         "heavyLoadsSystem": "Heavy load on the browser",
         "all": "All",
         "updateGroup": "Update group",
         "addGroup": "Add group",
         "addChildGroup": "Add child group",
         "forCurrentDevice": "For the selected vehicle",
         "resetShowLineTrackHelper": "Are you sure you want to continue? This will clear the previously loaded track",
         "colorTrack": "Track color",
         "colorVoyage": "Voyage color",
         "showFullTrackIfOnlyBuild": "Display full track (dashed)",
         "showFullTrackIfOnlyBuildTooltip": "Display the full track (dashed on the map) when only the traveled track is displayed",
         "sectorKey": "Sector key",
         "minLat": "Minimum latitude",
         "maxLat": "Maximum latitude",
         "minLng": "Minimum longitude",
         "maxLng": "Maximum longitude",
         "notes": "Note",
         "nothingDevices": "No vehicles found",
         "details": "Details",
         "deviceGroups": "Vehicle groups",
         "arrivalZone": "Arrival zone",
         "departureZone": "Departure zone",
         "showLineTrack": "Display traveled track",
         "searchByAddress": "Search by address",
         "searchByAddressOrCoordinates": "Search by address or coordinates",
         "timeInterval": "Time interval",
         "time": "Time",
         "showGeoZones": "Display geo-zones",
         "allSearchKeyFields": "Search in all fields",
         "general": "General",
         "total": "Total",
         "searchByCarrier": "Search by carrier",
         "searchByRoute": "Search by route",
         "searchField": "Search field",
         "route": "Route",
         "carrier": "Carrier",
         "save": "Save",
         "filters": "Filters",
         "minifiedMode": "Minified mode",
         "showColumns": "Show columns",
         "showColumnsMinifiedModeHelper": "Column display settings are not available in mini mode",
         "device": "Vehicle",
         "generalInfo": "General information",
         "devices": "Vehicles",
         "equipmentNav": "Equipment",
         "menuColor": "Menu colour",
         "menuColorCustom": "Custom colour",
         "menuColorAccount": "Account colour",
         "voyage": "Voyage",
         "heightM": "Height, m",
         "showOnlyTraveledTrack": "Display only traveled track",
         "dataOverTime": "Data over",
         "groupDevice": "Vehicle groups",
         "waitGeneratePdf": "Loading PDF file...",
         "waitLoading": "Loading...",
         "waitGenerateExcel": "Loading Excel file...",
         "satelliteCount": "Number of satellites",
         "resetActive": "Reset activity",
         "HDOP": "HDOP",
         "track": "Track",
         "action": "Action",
         "countEvent": "Number of events",
         "showStops": "Display stops",
         "showOnTheMap": "Show on the map",
         "mileageKM": "Mileage, km",
         "mileageSpeedKm": "Mileage (speed), km",
         "report": "Report",
         "startEventTime": "Start date",
         "endEventTime": "End date",
         "isLoading": "Loading...",
         "tableFileName": "table",
         "hideOnMap": "Hide on map",
         "notFound": "Nothing found...",
         "voyageId": "Voyage ID",
         "yes": "Yes",
         "routePointOrdinal": "Route point ordinal",
         "showPoint": "Display visited stops",
         "isEdgePoint": "Edge point",
         "geoZoneName": "Geo-zone",
         "geoZoneNotes": "Additional information",
         "showGeoZone": "Display geo-zones",
         "showParking": "Display parking",
         "sec": "sec",
         "min": "min",
         "hour": "hr",
         "enterTime": "From:",
         "exitTime": "To",
         "hideAllVoyage": "Hide all voyages",
         "showAllVoyage": "Show all voyages",
         "hideAll": "Hide all",
         "showAll": "Show all",
         "maxSpeedInZone": "Maximum speed",
         "averageSpeedInZone": "Average speed",
         "passedDistanceInZoneInKm": "Distance traveled (km)",
         "voyageActivationTime": "Voyage activation time",
         "voyageExpiredTime": "Voyage expiration time",
         "sector": "Sector",
         "exportRow": "Export",
         "no": "No",
         "speedLimit": "Speed limit",
         "object": "Vehicle",
         "group": "Group",
         "objectName": "Object",
         "hours": "Hours",
         "totalMileage": "Total mileage",
         "name": "Name",
         "additionalInfo": "Additional information",
         "baseInfo": "Basic information",
         "minutes": "Minutes",
         "home": "Home",
         "scheduleArrival": "Scheduled arrival",
         "realDeparture": "Actual departure",
         "realArrival": "Actual arrival",
         "departure": "Departure",
         "arrival": "Arrival",
         "dateStart": "Date from",
         "from": "From",
         "to": "To",
         "count": "Count",
         "dateEnd": "Date to",
         "countCircles": "Number of circles",
         "voyageTitle": "Voyage title",
         "accountGroups": "Groups",
         "search": "Search",
         "accountName": "Carrier",
         "show": "Show",
         "toApply": "Apply",
         "baseSettings": "Basic settings",
         "type": "Type",
         "groupsType": "Groups",
         "accountsType": "Carriers",
         "selectAllGroups": "Select all groups",
         "selectAllDevices": "Select all vehicles",
         "searchByLicensePlate": "Search by vehicle",
         "searchByPointName": "Search by stop name",
         "fact": "Fact",
         "plan": "Plan",
         "bySchedule": "By schedule",
         "stickyHeader": "Sticky headers",
         "skipped": "Skipped",
         "deviceType": "Objects",
         "voyageName": "Route name",
         "searchKey": "Search by",
         "resetQueryParams": "Reset search parameters",
         "more": "More details",
         "createReport": "Build report",
         "fuelLevel": "Fuel level",
         "deviceName": "Object name",
         "createTrack": "Build track",
         "createSeparateTrack": "Build separate track for the vehicle",
         "createSeparateGroupTrack": "Build separate tracks for vehicles",
         "searchKeySettings": "Search field settings",
         "lat": "Latitude",
         "groupType": "Group type",
         "hdop": "HDOP",
         "lon": "Longitude",
         "duration": "Duration",
         "speed": "Speed",
         "heading": "Course",
         "altDevice": "Altitude",
         "status": "Status",
         "wgAddress": "WG address",
         "lastHandshake": "Last contact",
         "handshakeOnline": "Online",
         "handshakeStale": "No contact for a long time",
         "handshakeNever": "Never connected",
         "publicKey": "Public key",
         "cameraSubnet": "Camera subnet",
         "pending": "Pending",
         "failed": "Failed",
         "deviceId": "Vehicle ID",
         "accountCode": "Carrier",
         "protocolCode": "Server type",
         "active": "Active",
         "motionStatusCodeDescription": "Status",
         "longitude": "Longitude",
         "latitude": "Latitude",
         "deviceMark": "Vehicle model",
         "simpleGroup": "Simple group",
         "routeGroup": "Route group",
         "latLng": "Latitude/Longitude",
         "imei": "IMEI",
         "simPhoneNumber": "Phone",
         "licensePlate": "License plate",
         "displayName": "Object brand",
         "description": "Description",
         "equipmentType": "Object class",
         "lastEventTime": "Last data time",
         "stopTime": "Last stop time",
         "engineHours": "Engine hours",
         "altitude": "Altitude",
         "trackColor": "Track color",
         "GPSOdomKM": "Odometer readings",
         "countGprsTraffic": "GPRS traffic",
         "dailyOdometer": "Daily odometer",
         "realAddress": "Address",
         "visitedGeoZone": "Geo-zone",
         "rawData": "Raw sensor data",
         "currentVoyageId": "Voyage ID",
         "flightId": "Flight ID",
         "driver": "Driver",
         "currentVoyageRouteId": "Route ID",
         "currentVoyageRouteName": "Route name",
         "currentVoyageDriverName": "Driver on route",
         "currentVoyageDriverPhone": "Driver phone number on route",
         "hideLastVoyage": "Hide last voyage",
         "showLastVoyage": "Show last voyage",
         "hideLastTargetInfo": "Hide vehicle",
         "showLastTargetInfo": "Show vehicle",
         "groups": "Groups",
         "state": {
             "stopping": "Stopping",
             "motion": "Motion",
             "parked": "Parked",
             "towingStart": "Towing start"
         },
         "pageCrashedTitle": "Something went wrong",
         "pageCrashedText": "This part of the page could not be shown. The rest of the app works.",
         "tryAgain": "Try again",
         "video": "Video",
         "saveChanges": "Save changes",
         "routesMultiple": "voyage(s)",
         "recipient": "Recipient",
         "history": "History",
         "cameraNumber": "Camera number",
         "conductor": "Conductor",
         "isScanned": "Scanned",
         "messageDetails": "Message details",
         "provider": "Provider",
         "notIsScanned": "Not scanned",
         "deletePoint": "Delete stop",
         "responsible": "Responsible",
         "trackableObjects": "Tagged objects",
         "mechanic": "Mechanic",
         "tag": "Tag",
         "iccid": "ICCID (SIM card ID)",
         "lastUpdated": "Last updated",
         "changeCount": "Number of changes",
         "firstDetected": "First detected",
         "doctor": "Doctor",
         "manager": "Manager",
         "readerCode": "Code",
         "account": "Account",
         "serialNumber": "Serial number",
         "rfid": "RFID zone",
         "readers": "Readers",
         "pointTemplate": "Template stop",
         "version": "Version",
         "default": "Default",
         "singleVoyageDriver": "Single voyage driver",
         "pedestrian": "Pedestrian",
         "garbage": "Waste bin",
         "employees": "Employees",
         "sms": "SMS",
         "respond": "Sending",
         "toPlan": "Plan",
         "success": "Success",
         "templates": "Templates",
         "rateLimitPerMinute": "rate limit per minute",
         "numbers": "Numbers",
         "register": "Log",
         "inbox": "Inbox",
         "settings": "Settings",
         "send": "Send",
         "driverCode": "Code word",
         "addEmployee": "Add employee",
         "showCameraSnapshots": "Photos",
         "photos": "Photos",
         "photo": "Photo",
         "photosAllList": "All photos",
         "prediction": "Prediction",
         "tableNumber": "Personnel number",
         "badge": "Badge",
         "user": "User",
         "restartVoyage": "Put the voyage back to work",
         "restartVoyageHint": "Did the voyage close early because another voyage started on this vehicle? Remove that voyage first, then press here: this one becomes active again with the same vehicle and driver. Possible until {{time}}.",
         "reassignActiveVoyage": "Swap vehicle / driver",
         "finishVoyage": "Finish voyage",
         "finishVoyageHint": "The voyage finishes now, like «Remove from voyage» in the old planning. It is not deleted: it stays in reports, but only what was covered before finishing counts. After that the same or another vehicle or driver can be assigned to this release again.",
         "finishVoyageConfirm": "The voyage will be finished now: only what was covered up to this minute goes into the report. Confirm.",
         "printVoyageLetter": "Print the waybill",
         "printVoyageLetterSaveFirst": "Save the changes first: the waybill is printed from what is already in the system.",
         "reassignActiveVoyageHint": "The swap applies at once: the voyage continues with the chosen vehicle and driver.",
         "visitedWaypoints": "Stops visited",
         "nextPoint": "Next stop",
         "cameras": "Cameras",
         "monitoringPlatform": "Intelligent monitoring platform",
         "cameraId": "Camera ID",
         "zoneRecordingMode": "Video recording at stops",
         "zoneRecordingModeHint": "Turns on video recording when the vehicle enters a stop. Records only during a voyage; nothing is recorded outside a voyage.",
         "cameraPosition": "Camera position",
         "hostName": "Host",
         "addCamera": "Add camera",
         "editCamera": "Edit camera",
         "cameraCounter": "Number of cameras",
         "isActive": "Photo capture on",
         "isActiveHint": "Takes a photo every minute all the time, regardless of voyages and stops.",
         "predictedDistanceMeters": "Distance (m)",
         "files": "Files",
         "operationType": "Operation type",
         "voyagesAudit": "Planning changes",
         "factStart": "Start",
         "totalWaypoints": "Total stops",
         "factEnd": "End",
         "predictedTime": "Predicted time",
         "predictedToNextPoint": "Prediction to the next stop",
         "showAllVoyages": "Show all routes",
         "hideAllVoyages": "Hide all routes",
         "showPredictionToNextPoint": "Show the planned path to the next stop",
         "showPoints": "Show stops",
         "activationType": "Activation type",
         "arrivalTime": "Arrival time",
         "nothingComments": "No comments",
         "departureTime": "Departure time",
         "enteringTheStop": "Entering the stop",
         "scanningTrackableObject": "Scanning objects",
         "plannedStartShort": "Planned start",
         "plannedEndShort": "Planned end",
         "build": "Build",
         "tagCode": "Code",
         "scanTime": "Scan time",
         "showTrackBuffer": "Show the planned track buffer",
         "showPlannedTrack": "Show the planned track",
         "showDevice": "Show vehicle",
         "showDeviceLastInfo": "Show the current vehicle location",
         "showDevicesLastInfo": "Show the current vehicle locations",
         "startVoyage": "Start voyage",
         "showTrack": "Show track",
         "updateDeviceAndDriver": "Change vehicle and driver",
         "stopVoyage": "Finish voyage",
         "deleteVoyages": "Delete voyages",
         "youSuccessVoyagePlanning": "Planned successfully",
         "youSuccessDeleteVoyagePlanning": "Deleted successfully",
         "addOrUpdateVoyages": "Add/update voyages",
         "confirmMessageCheckClearSaved": "Are you sure you want to continue? Unsaved changes will be cleared",
         "planned": "Plan",
         "localSave": "Standard",
         "serverSave": "Instant",
         "checkAndSave": "Check and save",
         "notDevice": "No vehicle",
         "voyagePlanned": "Plan voyages",
         "voyagePlannedWithoutCheck": "Plan voyages without checking",
         "hasPlannedRestSchedulesInCurrentDay": "Plan all shifts of this day",
         "unknown": "Unknown",
         "clearLocalSlots": "Discard unsaved changes",
         "autoCompletionInMultiDays": "Fill the duty roster for several days",
         "hasPlannedDriverRestSchedulesInCurrentDay": "Add the driver to the other shifts",
         "suchChangesWillOverwritten": "These changes will be overwritten",
         "confirmTitlePlannedRestSchedulesInCurrentDay": "Are you sure you want to plan the other shifts of this day?",
         "addTextTemplate": "Add text template",
         "selectAccount": "Select account",
         "appVersion": "App version",
         "fullBoard": "Whole board",
         "geoZonesHasZoomLevelControl": "Show geozones only when zoomed in",
         "geoZonesHasZoomLevelControlAllGeom": "Show sectors only when zoomed in",
         "tasks": "Tasks",
         "assignmentStatus": "Assignment status",
         "planCompletionTime": "Planned completion time",
         "hasPlanCompletionTime": "Set the planned completion time",
         "hasTimeStart": "Set the start time",
         "hasTimeEnd": "Set the end time",
         "selectAllBoard": "Select all boards",
         "moveLine": "Running line",
         "taskTemplate": "Task template",
         "withoutDevice": "No vehicle",
         "template": "Template",
         "templateText": "Text template",
         "withoutDriver": "No driver",
         "minBrightness": "Minimum brightness",
         "maxBrightness": "Maximum brightness",
         "textMoveSpeed": "Running line speed",
         "notDriver": "No driver",
         "configBoard": "Board settings",
         "text": "Text",
         "changeStatus": "Change status",
         "moveText": "Running line",
         "applyAs": "Apply as",
         "placeAfterName": "Place after the stop name",
         "min1max255Message": "The value must be between 1 and 255",
         "min1max60Message": "The value must be between 1 and 60",
         "min1max75Message": "The value must be between 1 and 75",
         "targetBoards": "Selected boards",
         "actionBoards": "Board actions",
         "notFountTargetBoards": "Nothing selected...",
         "resetBoard": "Restart board",
         "resetModem": "Restart modem",
         "resetTextLine": "Cancel running lines",
         "disabledItems": "Disconnected",
         "showBoard": "Show boards",
         "comands": "Commands",
         "enabledItems": "Connected",
         "boards": "Info boards",
         "phoneNumber": "Phone",
         "lastConnectionTime": "Last connection time",
         "hasAutoFill": "Turn on autofill",
         "reportsList": "Reports",
         "changeDate": "Change date",
         "change": "Change",
         "onlyTrackEnvironment": "This feature is available only in the TRACK environment",
         "createVoyageLetter": "Create waybills",
         "createVoyageLetterByTram": "Create waybills (trams)",
         "createVoyageLetterByTrolleybuses": "Create waybills (trolleybuses)",
         "errorLengthVoyageIds": "No releases are planned for this period",
         "createDayOutfit": "Create the daily duty roster",
         "createDayOutfitByTram": "Create the daily duty roster (trams)",
         "createDayOutfitByTrolleybuses": "Create the daily duty roster (trolleybuses)",
         "createDriverSchedule": "Create schedules for drivers",
         "emptyDriverSchedule": "No active schedules to create",
         "notAssignedVoyagePlanned": "Not assigned",
         "assignedVoyagePlanned": "Assigned (driver and vehicle)",
         "semiAssignedVoyagePlanned": "Partly assigned (vehicle only)",
         "viewMode": "View mode",
         "scaleViewMode": "Scaled",
         "defaultViewMode": "Normal",
         "paginationViewMode": "Pages",
         "listViewMode": "Compact list",
         "deletePlanning": "Delete planning",
         "voyagePlanning": "Voyage planning",
         "voyageStadium": "Voyage schemes",
         "notObject": "No object",
         "helperResetPageMessage": "Greater than the total count",
         "currentPage": "Current page",
         "updated": "Updated",
         "showReportErrors": "Show report errors",
         "reset": "Reset",
         "clearAll": "Clear all",
         "selectAll": "Select all",
         "online": "Online",
         "planingDate": "Planning time",
         "hideRadius": "Hide radius",
         "showRadius": "Show radius",
         "radius": "Radius",
         "ignoreDrains": "Ignore drains",
         "ignoreFills": "Ignore fills",
         "deviceActivity": "Vehicle activity",
         "oneHourLastOnline": "Online less than an hour ago",
         "beforeLastMonth": "Online more than a month ago",
         "inactive": "Not serviced",
         "lastDay": "Online less than a day ago",
         "lastMonth": "Online less than a month ago",
         "lastWeek": "Online less than a week ago",
         "notConnected": "Never connected",
         "routingGroup": "Route group",
         "pointLatLng": "Point coordinates",
         "chartActivity": "Activity chart",
         "typeChart": "Chart type",
         "barChart": "Bar chart",
         "pieChart": "Pie chart",
         "groupInfo": "Group information",
         "relatedGroups": "Available groups",
         "visibleForMultiAccount": "Visible to the multi-account",
         "errorAccess": "You have no access...",
         "vehicleModelGroup": "Vehicle model",
         "separatedRowDataColumns": "Separate raw data",
         "showDirectionOfMovement": "Show the direction of movement",
         "enabledOptimisticMode": "Turn on optimized mode",
         "addComment": "Add comment",
         "updateComment": "Update comment",
         "comment": "Comment",
         "comments": "Comments",
         "multiGroup": "Multi group",
         "message": "Message",
         "selectCarrier": "Select carrier",
         "saveChange": "Save changes",
         "download": "Download",
         "enterRouteName": "Enter the route name",
         "enterPointName": "Enter the stop name",
         "singleVoyageShort": "Single voyage",
         "fullName": "Full name",
         "create": "Creation",
         "update": "Update",
         "delete": "Deletion",
         "changes": "Changes",
         "selectGeoGroups": "Select geo groups",
         "selected": "Selected",
         "available": "Available",
         "filterByCarrier": "Filter by carrier",
         "startTime": "Start",
         "endTime": "End",
         "assignmentWorkDuration": "Task duration",
         "numberStop": "No.",
         "routeExecution": "Route execution",
         "hasGpsSignal": "GPS signal",
         "percent": "Percent",
         "assignmentStartTime": "Task start",
         "assignmentEndTime": "Task end",
         "percentOfCompletion": "Completion, %",
         "distanceTraveled": "Distance covered",
         "voyages": "Releases",
         "label": "Name",
         "importFromDevices": "Import from devices",
         "source": "Source",
         "entrance": "Entry",
         "exited": "Exit",
         "number": "Number",
         "enterManually": "Enter manually",
         "scheduleName": "Release name",
         "scheduleOrdinal": "Release number",
         "clearAllDevices": "Clear all vehicles",
         "searchByName": "Search by name",
         "separateByDevice": "Split by vehicle",
         "separateLines": "separate rows",
         "createdDateTime": "Created",
         "durationMinutesAndSeconds": "Duration (min:sec)",
         "accounts": "Accounts",
         "downloadCsv": "Download CSV",
         "info": "Info",
         "chat": "Chat",
         "expected": "Expected",
         "visited": "Visited"
     },
     "reqText": "Required field",
     "minLength1": "Field cannot contain less than 1 character",
     "minLength0": "Required field",
     "mustHaveNumber": "Must be a number",
     "onlyString": "Only letters",
     "valueMinLength2": "Must consist of at least 2 values",
     "errors": {
         "onlyTrackEnvironment": "This service is only available in the track environment"
     },
     "mapObject": "Maps",
     "voyage": "Voyage",
     "reportBuilder": "Builder",
     "journal": "Reports",
     "voyageTable": "Services",
     "singleVoyageMenu": "Single voyage",
     "singleVoyage": {
         "closeStops": {
             "title": "Stops are too close",
             "pair": "«{{first}}» and «{{second}}» are {{distance}} m apart with a {{radius}} m radius.",
             "fixRadius": "Reduce the radius to {{radius}} m or merge them into one stop.",
             "fixMerge": "Merge them into one stop: the radius cannot be below {{radius}} m.",
             "pairShort": "Stops {{first}} and {{second}} are {{distance}} m apart with a {{radius}} m radius.",
             "resize": "Reduce the radius to {{radius}} m",
             "editStop": "Edit stop template {{number}}",
             "remove": "Remove {{number}}",
             "show": "Show",
             "lockedRadius": "A template stop takes its radius from Stop templates.",
             "map": {
                 "title": "Zones of stops {{first}} and {{second}} overlap",
                 "sizes": "Centres are {{distance}} m apart. Radius of {{first}} is {{radiusFirst}} m, radius of {{second}} is {{radiusSecond}} m.",
                 "inside": "The centre of stop {{inner}} is inside the zone of stop {{outer}} ({{depth}} m from its edge): a vehicle at it is at the other too, so the visit counts for only one.",
                 "insideBoth": "The centre of each stop is inside the zone of the other ({{depth}} m from its edge): a vehicle at one is at the other too, so the visit counts for only one.",
                 "near": "The centre of stop {{inner}} is only {{gap}} m from the zone of stop {{outer}}: a vehicle standing a little off {{inner}} is in the zone of {{outer}}.",
                 "nearBoth": "Each stop's centre is only {{gap}} m from the other zone: a vehicle standing a little off a stop is in the zone of its neighbour.",
                 "fixTitle": "How to fix",
                 "fixRadius": "Radius of {{number}}: {{from}} → {{to}} m",
                 "fixTemplateRadius": "Radius of {{number}}: {{from}} → {{to}} m (in the stop template)",
                 "orMerge": "or merge them into one stop."
             },
             "whyShort": "A vehicle at one of them is already in the zone of the other, so the visit counts for only one. Several containers can be bound to one stop.",
             "apiErrorStops": "Some stops stand inside each other's radius, so a visit would count for only one of them. Reduce the radius or merge the stops.",
             "apiError": "The stop would stand inside the radius of another stop of a voyage template, so a visit would count for only one of them. Reduce the radius or pick another place."
         },
         "driverMessages": "Driver messages",
         "voyageTitleLabel": "Voyage: {{title}}",
         "driverMessagesUnread": "Unread from the driver: {{count}}",
         "driverMessagesEmpty": "No conversation yet",
         "driverMessagesEmptyHint": "Write to the driver — the message reaches them in the app.",
         "driverMessagesPlaceholder": "Write to the driver…",
         "driverNotAssigned": "No driver assigned",
         "send": "Send",
         "sendHint": "Enter to send, Shift+Enter for a new line",
         "editHint": "Esc to cancel",
         "today": "Today",
         "yesterday": "Yesterday",
         "roleDriver": "Driver",
         "roleDispatcher": "Dispatcher",
         "navigate": {
             "monitoring": "Monitoring",
             "planned": "Planned",
             "active": "Active",
             "archive": "Archive",
             "voyageTemplates": "Voyage templates",
             "planning": "Planning",
             "tasksTemplate": "Task templates",
             "pointTemplates": "Stop templates",
             "trackableObjects": "Tagged objects",
             "readers": "Readers",
             "video": "Video",
             "reports": "Reports"
         },
         "monitoring": {
             "stopsProgress": "{{done}} of {{total}} stops",
             "updatedAt": "updated {{time}}",
             "minutesAgo": "{{count}} min ago",
             "hoursAgo": "{{count}} h ago",
             "justNow": "just now",
             "noDevice": "No vehicle assigned",
             "noDeviceData": "no vehicle data yet",
             "noDriver": "no driver",
             "plannedShort": "pl.",
             "now": "now",
             "kmH": "km/h",
             "motion": {
                 "motion": "Moving",
                 "parking": "Parked",
                 "stopping": "Stopped",
                 "unknown": "No connection"
             },
             "openActiveVoyage": "Open active voyage"
         },
         "voyageTemplate": {
             "badge": {
                 "column": "Template",
                 "fromTemplate": "From template “{{title}}”",
                 "deleted": "template deleted",
                 "diverged": "edited by hand",
                 "outdated": "differs from template",
                 "outdatedHint": "The template changed but this voyage has not — click to update it from the template.",
                 "divergedHint": "The route or time of this voyage was edited by hand, so template updates skip it unless it is forced."
             },
             "deleteWithVoyages": "{{count}} voyages are planned from this template. They stay, but will no longer follow the template and drop out of the planning grid. Delete the template?",
             "create": "Create voyage template",
             "settings": "Template settings",
             "startTime": "Start time",
             "endTime": "End time",
             "duration": "Duration",
             "crossesMidnight": "crosses midnight",
             "startTimeInvalidMessage": "Invalid start time",
             "endTimeInvalidMessage": "Invalid end time",
             "endTimeEqualsStartMessage": "End time must differ from start time",
             "notFound": "Voyage template not found...",
             "createStopHere": "Create a stop here",
             "stopCatalog": "Stop catalogue",
             "hideStopCatalog": "Hide the stop catalogue",
             "deleteByRightClick": "right click to delete the voyage",
             "planning": "Planning from templates",
             "plan": "Plan",
             "planningHint": "Pick a date range, then create a voyage for the day you need from any template. Start time and duration come from the template; activation is always on schedule.",
             "pastSlotHint": "The start time has already passed, so a scheduled voyage cannot be created",
             "driverNotifiedHint": "The driver gets a push notification as soon as the voyage is created.",
             "editStop": {
                 "open": "Edit the stop",
                 "title": "Edit stop",
                 "hint": "Drag the marker on the map to move the stop. Changes are saved to the stop itself and apply to every voyage template that uses it.",
                 "savedSaveTemplate": "The stop is saved. Save the template, then the voyages that use it can be updated.",
                 "rebuildFailed": "The stop is saved, but the route could not be rebuilt for its new position.",
                 "retry": "Rebuild the route again"
             },
             "sync": {
                 "open": "Update planned voyages",
                 "outdatedCount": "Voyages that differ from the template: {{count}} — update",
                 "title": "Update planned voyages of the template",
                 "hint": "Voyages created from this template will be brought in line with it: stops, their order, route and time. Vehicle, driver, title and tasks stay as they are.",
                 "noVoyages": "All planned voyages already match the template.",
                 "stops": "Route stops",
                 "voyages": "Planned voyages: {{count}}",
                 "later": "Later",
                 "close": "Close",
                 "apply": "Update voyages: {{count}}",
                 "result": "Voyages updated: {{updated}}, skipped: {{skipped}}",
                 "divergedHint": "The voyage was edited by hand ({{date}}). Tick it to overwrite it from the template.",
                 "forceWarning": "The ticked hand-edited voyages will be overwritten from the template, losing their manual edits.",
                 "routeStale": "The route is out of date: a stop was moved. Open the template to rebuild the route.",
                 "routeStaleShort": "Route out of date",
                 "rebuildRoute": "Rebuild route",
                 "routeRebuilt": "The route was rebuilt for the new stop positions - check it and save the template.",
                 "stopUsedIn": "The stop is used in voyage templates",
                 "stopUsedInHint": "Planned voyages of these templates can be updated. If the stop was moved, rebuild the template route first.",
                 "stopUsedInCount": "Voyage templates: {{count}}",
                 "movedDraft": "The stop has been moved. The new position applies once you save the changes.",
                 "movedDraftCancel": "Put it back",
                 "summary": {
                     "ready": "to update: {{count}}",
                     "updated": "updated: {{count}}",
                     "diverged": "edited by hand: {{count}}",
                     "skipped": "skipped: {{count}}"
                 },
                 "wasNumber": "was #{{number}}",
                 "unchangedStops": "#{{from}}-#{{to}} unchanged ({{count}} stops) - show",
                 "unchangedShort": "{{count}} unchanged",
                 "collapse": "collapse",
                 "movedStopTooltip": "#{{number}} moved",
                 "movedStopTooltipDistance": "#{{number}} moved by {{distance}} m",
                 "oldStopTooltip": "#{{number}} — old position",
                 "movedStopLabel": "Moved - route rebuilt",
                 "rebuiltTitle": "The route was rebuilt for the new stop positions",
                 "rebuiltMoved": "Moved stops: #{{numbers}}",
                 "rebuiltCheck": "Check the route and save the template.",
                 "divergedBanner": "This voyage was edited by hand (last saved {{date}}). The differences below mix manual edits and template changes; updating the voyage makes all of it match the template.",
                 "detail": {
                     "moved": "moved by {{value}} m",
                     "NAME": "name",
                     "ADDRESS": "address",
                     "RADIUS": "radius",
                     "TYPE": "type",
                     "TIMES": "planned times at the stop will be cleared",
                     "metres": "{{value}} m",
                     "types": {
                         "POINT_RADIUS": "regular",
                         "RFID_POINT": "RFID",
                         "POLYGON": "polygon"
                     }
                 },
                 "legend": {
                     "newRoute": "new route",
                     "oldRoute": "old route",
                     "changedRoute": "changed stretch",
                     "movedStop": "moved stop",
                     "added": "added",
                     "changed": "changed",
                     "oldPosition": "old position",
                     "removed": "removed"
                 },
                 "outcome": {
                     "READY": "Will be updated",
                     "UPDATED": "Updated",
                     "DIVERGED": "Edited by hand",
                     "TOO_LATE": "Starts too soon",
                     "TASKS_ON_REMOVED_STOP": "Tasks on a removed stop",
                     "DEVICE_BUSY": "Vehicle busy at this time",
                     "INVALID": "Cannot be updated",
                     "NOT_FOUND": "Voyage not found"
                 },
                 "change": {
                     "ROUTE": "Route changed"
                 }
             },
             "createFromVoyage": "Save as voyage template",
             "confirmCreateFromVoyage": "Create a voyage template from this voyage? The route, stops, start time and duration will be copied.",
             "createdFromVoyage": "Voyage template created: it is in «Voyage templates»",
             "manualVoyageTimeHint": "A manual voyage has no planned window: set the hours when this voyage should run by the template."
         },
         "createVoyage": "Create voyage",
         "pointName": "Stop name",
         "nothingData": "No data yet...",
         "saveAndSchedule": "Save and schedule",
         "changeAdjustingPoints": "Change adjusting points",
         "searchPointsFromPastVoyages": "Find stop from past voyages",
         "searchPoints": "Find stop",
         "saveAdjustingPoints": "Save adjusting points",
         "confirmBuildPositionsMessage": "Are you sure you want to continue? This will possibly clear the adjusting points",
         "estimatedTimeArrival": "Estimated time of arrival",
         "scheduledVoyages": "Scheduled voyages",
         "activeVoyages": "Active voyages",
         "realTimeArrival": "Real time of arrival",
         "plannedStayStop": "Planned stay at stop",
         "realStayStop": "Real stay at stop",
         "status": "Status",
         "settingsRoute": "Route settings",
         "saveVoyage": "Save route",
         "fixationRadiusGeozone": "Fixation radius (geozone)",
         "numberStop": "Stop number",
         "countCompletedAssignments": "Number of completed tasks",
         "plannedStay": "Planned stay",
         "plannedStayStart": "Planned stay from",
         "plannedStayEnd": "Planned stay to",
         "scheduledTime": "Scheduled time",
         "confirmDeleteScheduleVoyage": "Warning! You are about to delete the scheduled voyage, continue deletion?",
         "assignment": "Assignment",
         "dateTimeRouteStart": "Voyage start",
         "dateTimeRouteEnd": "Voyage end",
         "plannedDateTimeRouteStart": "Planned voyage start",
         "plannedDateTimeRouteEnd": "Planned voyage end",
         "factDateTimeRouteStart": "Actual voyage start",
         "factDateTimeRouteEnd": "Actual voyage end",
         "tripIdAccordingToDatabase": "Trip ID according to the database",
         "progress": "Progress",
         "licensePlate": "Vehicle license plate",
         "completedTasksCount": "Number of completed tasks",
         "device": "Vehicle",
         "totalPointCount": "Total number of stops",
         "driver": "Route executor",
         "optimalRouteControl": "Optimal route control",
         "strictStopOrder": "Strict stop order",
         "notifyDriverAboutTrip": "Notify driver about the trip",
         "tasks": "Tasks",
         "nothingTasks": "You have not added any tasks yet",
         "nothingTasksInPoint": "No tasks at this stop",
         "addTask": "Add task",
         "namePlaceholderTask": "Give a short name to this task",
         "descriptionPlaceholderTask": "Describe the task in detail",
         "photoReport": "Photo report",
         "hasPhotoReport": "Has photo report",
         "trackArrivalTimeAtFirstStop": "Track arrival time at the first stop",
         "trackArrivalTimeAtLastStop": "Track arrival time at the last stop",
         "minPointLengthMessage": "Minimum number of stops - 2",
         "notFoundVoyage": "Voyage not found...",
         "updateVoyage": "Edit voyage",
         "deleteVoyage": "Delete voyage",
         "tasksTemplates": "Task templates",
         "reorderPoints": "Reorder stops",
         "showVoyage": "View voyage",
         "subtasks": "Subtasks",
         "taskCount": "Number of tasks",
         "updateTasks": "Update tasks",
         "plannedArrival": "Planned arrival",
         "createTrack": "Build track",
         "track": "Track",
         "completePoints": "Stops completed",
         "completeTasks": "Tasks completed",
         "changeAssignment": "Change assignee",
         "isNotCompleteCurrentTargetAssignment": "Handled by another assignee",
         "selectAssignment": "Select assignee",
         "loadedOldTasks": "Load tasks from a voyage",
         "addTaskTemplate": "Add task template",
         "taskDetailsType": "Task template",
         "basicTaskDetailsType": "Basic",
         "photoRequired": "Photo report",
         "unitDelivery": "Delivery",
         "reports": "Reports",
         "reportExecution": "Voyage work report",
         "reportRfid": {
             "title": "RFID tag report",
             "plannedSites": "Points planned",
             "visitedSites": "Points visited",
             "plannedBins": "Tags planned",
             "uniqueBinsServed": "Unique reads",
             "binStates": {
                 "read": "Collected",
                 "readOutsideGeofence": "Collected (outside the geozone)",
                 "notRead": "Not read",
                 "readAtOtherSite": "Other point",
                 "readAtOtherSiteNamed": "Read at «{{site}}»",
                 "readNotCredited": "Read, not credited",
                 "foreignBin": "Foreign bin",
                 "unplannedBin": "Unplanned"
             },
             "sheet": {
                 "title": "Solid waste collection report",
                 "voyageLine": "Voyage No. {{id}} «{{title}}»",
                 "generatedAt": "generated {{value}}",
                 "print": "Print",
                 "excel": "Save to Excel",
                 "pdf": "Save PDF",
                 "driver": "Driver",
                 "vehicle": "Vehicle",
                 "duration": "Voyage took",
                 "distance": "Mileage",
                 "stops": "Stops",
                 "bins": "Containers",
                 "served": "Collected",
                 "notRead": "Not read",
                 "otherSite": "Other point",
                 "notCredited": "Not credited",
                 "unplanned": "Unplanned",
                 "arrival": "arrival",
                 "departure": "departure",
                 "onSite": "on site",
                 "minutesShort": "min",
                 "kmShort": "km",
                 "siteBins": "containers",
                 "siteServed": "collected",
                 "siteNotRead": "not read",
                 "siteOtherSite": "read at another point",
                 "siteNotCredited": "not credited",
                 "siteUnplanned": "unplanned",
                 "columnNumber": "No.",
                 "columnBin": "Container",
                 "columnTag": "Tag",
                 "columnState": "State",
                 "columnTime": "Time",
                 "columnReads": "Reads",
                 "columnNote": "Note",
                 "noTag": "no tag",
                 "noTagNote": "tag not registered",
                 "outsideGeofence": "outside the geozone",
                 "repeatLift": "repeat lift",
                 "totalLine": "Voyage total: {{bins}} containers, {{served}} collected, completion {{percent}} %",
                 "outsideSitesLine": ", outside stops {{count}}",
                 "signature": "signature of the responsible person",
                 "noBins": "No containers at this point",
                 "noSites": "The voyage has no points with containers",
                 "expandAll": "Expand all",
                 "collapseAll": "Collapse all",
                 "scanned": "{{read}} of {{total}} read",
                 "videos": "Videos from the stop",
                 "videosCount": "Videos from the stop ({{count}})"
             }
         },
         "reportSheet": {
             "backToVoyages": "Back to single voyages",
             "executionTitle": "Voyage work report",
             "rfidTitle": "RFID tag report",
             "dailyTitle": "Voyage execution for the day",
             "period": "Period {{start}} — {{end}}",
             "day": "For {{day}}",
             "voyagesList": "Voyages",
             "openHint": "Click a voyage to open its detailed report",
             "empty": "No voyages for the selected period",
             "voyages": "Voyages",
             "drivers": "Drivers",
             "vehicles": "Vehicles",
             "stops": "Stops",
             "bins": "Containers",
             "served": "Collected",
             "completion": "Completion",
             "distance": "Mileage, km",
             "onRoute": "On route, km",
             "outRoute": "Off route, km",
             "columnNumber": "No.",
             "columnVoyage": "Voyage",
             "columnStatus": "Status",
             "columnDriver": "Driver",
             "columnVehicle": "Vehicle",
             "columnFact": "Actual",
             "columnDuration": "Duration",
             "columnWork": "Work",
             "columnStops": "Stops",
             "columnBins": "Containers",
             "columnCompletion": "Completion",
             "columnDistance": "Mileage, km",
             "columnOnRoute": "On route",
             "columnOutRoute": "Off route"
         },
         "reportDailyExecution": {
             "title": "Daily execution",
             "breadcrumb": "Voyage execution for the day",
             "day": "Day",
             "totals": "Day total",
             "voyagesCount": "Voyages",
             "sites": "Points visited / planned",
             "bins": "Tags read / planned",
             "onRouteDistance": "Mileage on route, km",
             "outRouteDistance": "Mileage off route, km",
             "totalDistance": "Total mileage, km",
             "vehicle": "Vehicle",
             "allVoyages": "All voyages of the day",
             "vehicleSheet": {
                 "title": "Vehicle sheet for the day",
                 "issued": "Issued",
                 "vehicle": "Vehicle",
                 "date": "Date",
                 "columnNumber": "No.",
                 "columnName": "Stop name",
                 "columnAddress": "Address",
                 "columnBins": "Containers",
                 "columnVolume": "Volume",
                 "columnSchedule": "Schedule, {{weekday}}",
                 "columnTrip": "Trip {{number}}",
                 "columnNote": "Note",
                 "empty": "The vehicle had no voyages this day"
             }
         },
         "addSubtask": "Add subtask",
         "taskTemplate": "Task template",
         "errorCreateTasks": "Failed to create tasks.",
         "noLimit": "No limit",
         "planCompletionTime": "Planned completion time",
         "singleWaypointLimit": "One stop",
         "waypointLimit": "Limit",
         "activeVoyage": "Active voyage",
         "createNewVoyageFromCurrent": "Create a new voyage from the selected one (advanced)",
         "quickCreateNewVoyageFromCurrent": "Create a new voyage from the selected one",
         "quickCreateNewVoyageFromCurrentWithAutoTasksLoad": "Create a new voyage from the selected one (load tasks automatically)",
         "historyVoyage": "Voyage history",
         "deviceBusyOnStart": "The vehicle is busy with another voyage. Finish it or choose another vehicle.",
         "deviceBookedForPlannedVoyage": "Another voyage is already planned for this vehicle. If you start now, that voyage will not start on schedule. Choose another vehicle or cancel the planned voyage.",
         "deviceWindowOverlap": "The vehicle is already busy with another voyage at this time. Choose another time or another vehicle.",
         "successStartVoyage": "The voyage has started!",
         "successArchiveVoyage": "The voyage was moved to the archive",
         "archiveVoyage": "Archive",
         "confirmArchiveVoyage": "Move the voyage to the archive? It disappears from the planned list but stays in the archive, where you can make a copy of it.",
         "successStopVoyage": "The voyage has finished!",
         "statuses": {
             "draft": "Draft",
             "readyForManualRun": "Manual activation",
             "plannedForAutorun": "On schedule",
             "manualRun": "In progress",
             "plannedRun": "In progress",
             "plannedManualRun": "In progress",
             "plannedCompleted": "Completed as planned",
             "plannedInterrupted": "Completed early",
             "manualCompleted": "Completed manually",
             "deleted": "Deleted",
             "notStartedDeviceBusy": "Not started: vehicle busy",
             "archived": "Archived",
             "readyForManualRunSelect": "Manual activation",
             "readyForManualRunSelectWithDate": "Manual activation (with an approximate date)",
             "plannedForAutorunSelect": "Activation on schedule"
         },
         "selectRouteSegment": "Select a route segment",
         "selectRouteSegmentHint": "Between which stops to adjust the track",
         "statusFilter": {
             "all": "All"
         },
         "pointStatuses": {
             "planned": "Planned",
             "completed": "Completed",
             "skipped": "Skipped",
             "inProgress": "In progress",
             "deleted": "Deleted",
             "partialCompleted": "Partly completed"
         },
         "taskStatuses": {
             "planned": "Planned",
             "completed": "Completed",
             "inProgress": "In progress",
             "deleted": "Deleted",
             "cancelled": "Cancelled",
             "partialCompleted": "Partly completed"
         },
         "taskActions": "Task actions",
         "taskStates": {
             "planned": "Not started",
             "running": "In progress",
             "partial": "Partly done",
             "done": "Done",
             "failed": "Not done"
         },
         "tasksStopSummary": "Tasks · {{done}} of {{total}}",
         "executions": "Task stops",
         "selectAllWaypoints": "Select all ({{count}})",
         "clearAllWaypoints": "Clear selection",
         "markExecutionCompleted": "Done",
         "markExecutionCancelled": "Not done",
         "closeTask": "Close task",
         "closeTaskFully": "Close the task at all stops",
         "closeTaskAsCompleted": "Done at all stops",
         "closeTaskAsCancelled": "Not done at all stops",
         "closeTaskConfirm": "The action applies to all stops of the task: {{open}} of {{total}} will be closed. Stops already closed stay as they are.",
         "closeTaskNothingToClose": "All stops are already closed",
         "photoRequiredToComplete": "This stop needs a photo",
         "executionAlreadyClosed": "This stop is already closed"
     },
     "fuelInfo": "Fuel",
     "driversInfo": "Drivers",
     "accountInfo": "Admin panel",
     "dashboard": "Dashboard",
     "help": "Help",
     "legalNotice": "Documents",
     "accountAdmin": "System",
     "exportToExcel": "Export to Excel",
     "exportToExcelFull": "Export all data to Excel",
     "selectTableToExcel": "Select the tables you want to export",
     "selectAllRows": "Select all rows",
     "selectAllColumn": "Select all columns",
     "allClearColumn": "Clear columns",
     "allClearRows": "Clear rows",
     "closeExportMode": "Close export mode",
     "openExportMode": "Open export mode",
     "exportPdf": "Export to PDF format",
     "exportExcel": "Export to Excel format",
     "exportStyles": "Export appearance settings",
     "excel": "Excel",
     "pdfSettings": "Excel settings",
     "pdf": "PDF",
     "excelSettings": "PDF settings",
     "thin": "Thin",
     "medium": "Medium",
     "thick": "Thick",
     "hair": "Hairline",
     "paginationDisabledTooltip": "Wait for the loading to finish to navigate to another page",
     "wrapText": "Wrap text",
     "dashed": "Dashed",
     "typeAlignment": "Alignment",
     "mediumDashed": "Medium dashed",
     "dashDot": "Dash dot",
     "mediumDashDot": "Medium dash dot",
     "dashDotDot": "Dash dot dot",
     "mediumDashDotDot": "Medium dash dot dot",
     "slantDashDot": "Slant dash dot",
     "alignment": "Alignment",
     "topBorder": "Top",
     "bottomBorder": "Bottom",
     "leftBorder": "Left",
     "rightBorder": "Right",
     "diagonalBorder": "Diagonal",
     "border": "Border",
     "add": "Add",
     "update": "Update",
     "font": "Font",
     "fill": "Fill",
     "typeBorder": "Border type",
     "underline": "Underline",
     "hasFill": "Has fill",
     "patternTypeBg": "Fill pattern type",
     "addValue": "Add value",
     "autoWidth": "Number of column name characters",
     "color": "Color",
     "typeWidthColumn": "Column width type",
     "widthColumn": "Column width",
     "widthColumnTooltip": "You can set a fixed number of characters to determine the column width or base it on the number of characters in the column name",
     "wch": "Width in characters",
     "widthWch": "Fixed number of characters",
     "oneValue": "One value",
     "vertical": "Vertical",
     "horizontalAlignment": "Horizontal alignment",
     "verticalAlignment": "Vertical alignment",
     "bottomAlignment": "Bottom",
     "leftAlignment": "Left",
     "centerAlignment": "Center",
     "rightAlignment": "Right",
     "justifyAlignment": "Justify",
     "topAlignment": "Top",
     "hasBackgroundText": "Has background text",
     "hasFillColor": "Has fill color",
     "fontSize": "Font size",
     "outline": "Outline",
     "bold": "Bold",
     "shadow": "Shadow",
     "pageOrientation": "Page orientation",
     "portrait": "Portrait",
     "landscape": "Landscape",
     "pageSize": "Page size",
     "italic": "Italic",
     "strike": "Strikethrough",
     "colorText": "NavigateText color",
     "pdfBaseExportStyles": "General PDF export settings",
     "exportStylesSettings": "General export settings",
     "saveExportStylesMessage": "Are you sure you want to save the export settings?",
     "exportLabels": {
         "exportDataFromAllPage": "Export data from all pages"
     },
     "mothStart": "Start of the month",
     "todayDay": "Today",
     "weekStart": "Start of the week",
     "weekEnd": "End of the week",
     "dateBetween": "Date intervals",
     "monthEnd": "End of the month",
     "monthPreviousStart": "Start of the previous month",
     "monthPreviousEnd": "End of the previous month",
     "yearDayStart": "First day of the year",
     "yearDayEnd": "Last day of the year",
     "quarterDayStart": "Start of the quarter",
     "quarterDayEnd": "End of the quarter",
     "fixedDate": "Fixed date",
     "templateDate": "Template",
     "date": {
         "currentDay": "Today",
         "lastDay": "Previous day",
         "currentWeek": "Current week",
         "currentMoth": "Current month",
         "currentQuarter": "Current quarter",
         "currentYear": "Current year",
         "last62Days": "Last 62 days",
         "previousMoth": "Previous month"
     },
     "updateReport": "Update report",
     "equal": "Equal",
     "notEqual": "Not equal",
     "selectAccount": "Select carrier",
     "lessThan": "Less than",
     "showConditionMessage": "A new condition will appear here",
     "greaterThan": "Greater than",
     "lessThanEqual": "Less than or equal",
     "greaterThanEqual": "Greater than or equal",
     "deleteReport": "Delete report",
     "existingReports": "Existing reports",
     "newReport": "Create new report",
     "sourceData": "Data source",
     "rootTable": "Main table",
     "saveConditionsConfirmMessage": "Are you sure you want to save the conditions?",
     "displayNameColumn": "Column name",
     "saveReportAsNew": "Save as new",
     "saveReportSuccessMessage": "You have successfully saved the report!",
     "updateReportSuccessMessage": "You have successfully updated the report!",
     "additionalTable": "Additional table",
     "uniqColumnIdMessage": "Column name must be unique",
     "newParams": "New parameter",
     "menuAddColumn": "Add column menu",
     "menuUpdatedColumn": "Update column menu",
     "updateColumn": "Update column",
     "sort": "Sort",
     "addColumn": "Add column",
     "report": "Report",
     "singleValue": "Single value",
     "multiValue": "Multiple values",
     "typeReport": "Report type",
     "saveColumnsConfirmMessage": "Are you sure you want to save the column?",
     "deleteColumnsConfirmMessage": "Are you sure you want to delete the column?",
     "closeColumnsConfirmMessage": "Are you sure you want to close the column settings without saving?",
     "closeExportStylesConfirmMessage": "Are you sure you want to close the export settings to PDF without saving?",
     "addCondition": "Add condition",
     "condition": "Condition",
     "confirmMessageCloseConfirm": "Are you sure you want to close the condition without saving?",
     "confirmMessageSaveSettingsConfirm": "Are you sure you want to save the settings?",
     "deleteConfirmMessageConditions": "Are you sure you want to delete the condition?",
     "updateCondition": "Update condition",
     "deleteReportSuccessMessage": "You have successfully deleted the report!",
     "columnNameData": "Database columns",
     "messageConfirmCloseColumn": "Are you sure you want to close the column?",
     "messageAddColumnsForDisplay": "Add columns for display...",
     "messageReportChangeSourceData": "Are you sure you want to change the data source? This will clear the columns and settings.",
     "messageReportChangeAdditionalData": "Are you sure you want to change the additional data source? This will clear the columns and settings.",
     "messageReportChangeAdditionalDataConditions": "Are you sure you want to change the additional data source? This will clear the settings.",
     "save": "Save",
     "columns": "Columns",
     "name": "Name",
     "description": "Description",
     "fileName": "File name",
     "confirmDeleteMessage": "Are you sure you want to delete?",
     "successDeleteMessage": "You have successfully deleted the data!",
     "logOut": "Log out",
     "notFound": "Nothing found...",
     "asc": "Ascending",
     "moreDetails": "More details",
     "direction": "Sort direction",
     "cancel": "Cancel",
     "confirm": "Confirm",
     "order": "Order",
     "showPage": "Show on page",
     "desc": "Descending",
     "account": "Carrier",
     "confirmAction": "Confirm action",
     "useAllAccounts": "Information from all carriers",
     "accountIdsHelper": "If you do not select any carrier, information will be obtained from all",
     "accounts": "Carriers",
     "dateStart": "Date from",
     "dateEnd": "Date to",
     "autoRefresh": "Auto-refresh",
     "device": "Vehicle",
     "ok": "Ok",
     "month": "Month",
     "years": "Year",
     "back": "Back",
     "clear": "Clear",
     "column": "Column",
     "value": "Value",
     "operator": "Operator",
     "yes": "Yes",
     "no": "No",
     "operatorBetweenDate": "Must be within range",
     "operatorNotBetweenDate": "Exclusion from range",
     "operatorNotInArray": "Does not contain (multiple values)",
     "operatorInArray": "Contains (multiple values)",
     "operatorAnd": "and",
     "operatorOr": "or",
     "STRING": "Text",
     "DATE": "Date",
     "BOOLEAN": "Yes/No",
     "multiValues": "Multiple values",
     "NUMBER": "Number",
     "LOGICAL": "Logical operator",
     "ARRAY": "Data set",
     "updateOperator": "Update operator",
     "intensitySkippedPoint": "Intensity of skipped stops",
     "settingsOnePointSkippedPointForFlagIcon": "Show red flag icon if at least 1 stop is missed",
     "settingsSkippedPointForFlagIconTooltip": "Percentage of skipped stops from the total number to display the red flag icon",
     "reportLabels": {
         "reports": "Reports",
         "readyReports": "Ready reports",
         "reportBuilder": "Report builder",
         "reportReceived": "Received data",
         "reportScheduleExecution": "Route execution report",
         "reportVoyagePointData": "Stop visit report",
         "reportGroupMileage": "Daily mileage report",
         "reportGroupMileageTitle": "Report on completed transport work on routes",
         "reportTrackerOutages": "Tracker outages report",
         "trackerOutages": {
             "gapMinutes": "No-connection threshold, min",
             "noFixMinutes": "No-position threshold, min",
             "type": "Outage type",
             "typeNoConnection": "No connection",
             "typeSpoofing": "Coordinates spoofing",
             "typeNoSatellites": "No satellites",
             "typeNoGpsFix": "No GPS fix",
             "startTime": "Start",
             "endTime": "End",
             "duration": "Duration",
             "lastPoint": "Disappeared near",
             "resumePoint": "Reappeared near",
             "displacementKm": "Straight-line displacement, km",
             "movingBefore": "Was moving before outage",
             "movedDuringOutage": "Displaced during outage",
             "outageCount": "Outages",
             "countByType": "By type",
             "totalSilentMinutes": "Without connection",
             "totalBlindMinutes": "Without position",
             "longestOutageMinutes": "Longest outage",
             "totalDisplacementKm": "Total displacement",
             "coveragePercent": "Coverage",
             "withoutOutages": "No outages found",
             "ongoing": "ongoing",
             "beforePeriod": "started before the period",
             "unknown": "unknown",
             "lessThanMinute": "< 1 min",
             "hoursShort": "h",
             "minutesShort": "min",
             "kmShort": "km"
         },
         "BatV": "Battery V",
         "BortV": "Board V",
         "bak": "Tank",
         "fuelDiff": "Fuel spent, l",
         "fuelExpense": "Fuel consumption, l/100 km",
         "fuelLevel": "Fuel in tank, l",
         "ignition": "Ignition",
         "reserveBattery": "Reserve battery",
         "selectDevice": "Select a vehicle to get data",
         "selectDeviceAndAccount": "Select a vehicle and carrier to get data",
         "licensePlate": "Vehicle",
         "driverName": "Driver",
         "voyageOrder": "Order",
         "routeName": "Route",
         "onlySkippedPointShow": "Show only skipped stops",
         "accountName": "Carrier",
         "voyagePointName": "Geozone",
         "scheduleArrivalTime": "Scheduled arrival time",
         "realArrivalTime": "Actual arrival time",
         "departureTime": "Departure time",
         "voyageName": "Route name",
         "longScheduleName": "Order, Circle",
         "skippedPoint": "Skipped stop",
         "percentPointsPassedInTime": "On-schedule",
         "mileageRouteFact": "Route mileage, km",
         "errorMessages": {
             "errorAccount": "You do not have access to the carrier",
             "errorGroup": "You do not have access to the group",
             "errorType": "This type of request does not exist",
             "errorDateFormat": "Invalid date format",
             "errorDevices": "You do not have access to the device"
         },
         "reportScheduleExecutionByRoutes": "Route work report (grouped by route)",
         "reportDevicePlanningExecution": "Route planning and execution report (by vehicle)",
         "reportFuelConsumption": "Fuel consumption report",
         "reportFuelConsumptionByDevice": "Fuel consumption report (for each vehicle)",
         "reportFuelConsumptionByRoute": "Fuel consumption report (for the whole route)",
         "reportGroupActiveSession": "Vehicle activity report",
         "prevVoyagePoint": "Previous geozone",
         "reportIccids": "Device ICCID report",
         "gap": "Time since the previous geozone",
         "reportVoyagePointAverages": "Stop visits report (summary)",
         "reportCarWashGeoZoneVisits": "Car wash visits report",
         "reportMileageSummary": "Group mileage for the period",
         "odometerStart": "Odometer (start), km",
         "odometerEnd": "Odometer (end), km",
         "drivers": "Drivers",
         "daysOnRoute": "Days on route",
         "reportErrors": "Errors",
         "time": "Time",
         "mileage": "Mileage",
         "startVoyage": "At the start of the release",
         "endVoyage": "At the end of the release",
         "start": "At the start",
         "end": "At the end",
         "reportLabels": "Has a fuel sensor",
         "startTimeVoyage": "Release start time",
         "endTimeVoyage": "Release end time",
         "odometerStartVoyage": "Mileage at the start of the release",
         "odometerEndVoyage": "Mileage at the end of the release",
         "durationRoute": "Route execution time",
         "fuelStartLevelVoyage": "Fuel at the start of the release",
         "fuelEndLevelVoyage": "Fuel at the end of the release",
         "fuelLevelDelta": "Fuel consumption",
         "totalFuelConsumption": "Fuel consumption with fills/drains",
         "consumptionPer100Km": "Consumption per 100 km",
         "filledFuel": "Filled",
         "drainedFuel": "Drained",
         "fillCount": "Fills",
         "drainCount": "Drains",
         "voyagePoint": "Geozone",
         "totalDailyMileage": "Daily mileage, km",
         "fromStop": "From",
         "toStop": "To",
         "samples": "Samples",
         "avg": "Duration"
     },
     "devices": {
         "devicesName": "Vehicle list",
         "selectedDevice": "Select vehicle",
         "moreSelectDevice": "Extended vehicle selection",
         "fields": {
             "accountCode": "Carrier",
             "active": "Active",
             "description": "Description",
             "displayName": "Object brand",
             "equipmentType": "Bus",
             "fuelLevel": 0,
             "heading": 352,
             "id": 120,
             "imei": "IMEI",
             "lastEventTime": "2023-03-22T12:58:38+02:00",
             "lastGPSOdomKM": "230472.31619575637",
             "latitude": "49.2524683",
             "legacyDeviceId": "BC-3269-AA",
             "licensePlate": "License plate",
             "longitude": "23.8489066",
             "phone": "+380678136026",
             "protocolCode": "teltonika",
             "sensors": "",
             "speed": "Speed",
             "uniqueCode": "ID",
             "accountName": "Carrier",
             "object": "Vehicle"
         }
     },
     "auth": {
         "signInTitle": "UA-GIS Trek:Sign in",
         "username": "Username",
         "password": "Password",
         "login": "Login",
         "signIn": "Sign in",
         "accountCode": "User",
         "logOut": "Log out",
         "loggedIngMessage": "You have successfully logged in!",
         "logOutMessage": "You have successfully logged out of the carrier!",
         "language": "Language",
         "backgroundColor": "Background colour",
         "dayMap": "Day map",
         "nightMap": "Night map",
         "demo": "Open demo",
         "or": "or",
         "forgotPassword": "Forgot your password?",
         "forgotPasswordHint": "Contact your manager to reset your password",
         "taglineTitle": "GPS tracking and dispatch",
         "taglineText": "A complete real-time fleet management system.",
         "formTitle": "Sign in",
         "formSubtitle": "Use the details your manager gave you",
         "errorCredentials": "Wrong login, user or password. If they are right, your access is off: contact your manager.",
         "errorUnavailable": "The server is not responding. Try again in a minute.",
         "trackPosition": "Position on the track",
         "scoreTitle": "Air defence",
         "defenceOn": "Turn on air defence mode",
         "disclaimerTitle": "Air defence mode",
         "disclaimerText": "This is a joke mini game and an easter egg from the author. It contains political satire. The author meant no offence to anyone: it is just humour and respect for those who defend our sky.",
         "disclaimerQuestion": "Start the game?",
         "disclaimerCancel": "Cancel",
         "disclaimerStart": "Start the game",
         "rewardTitle": "{{count}} down!",
         "rewardCoffin": "Putin in a coffin. The devil is back in hell.",
         "rewardKremlin": "The Kremlin is on fire. Air defence works.",
         "rewardBavovna": "Bavovna all over Russia.",
         "rewardCollapse": "Russia has fallen apart.",
         "rewardSunk": "Russia is gone from the map. The world is at peace.",
         "gloryToUkraine": "Glory to Ukraine!",
         "rewardClose": "Close",
         "defenceOff": "Turn off air defence mode",
         "scoreShaheds": "shaheds",
         "scoreJets": "jets",
         "scoreDrones": "drones"
     },
     "scheduleExecution": {
         "time": "Route start time, hrs",
         "arrivalTime": "Route end time, hrs",
         "departureTime": "Route start time, hrs",
         "arrivalTimeFact": "Route end time, hrs (actual)",
         "plannedCirclesCount": "Number of trips (planned)",
         "circlesCount": "Number of trips",
         "realCirclesCount": "Number of trips (actual)",
         "plannedToRealCirclesPercent": "Completed trips, %",
         "totalPointsPassed": "Number of stops (actual)",
         "pointsPassedInTime": "Number of stops (on schedule)",
         "percentPointsPassedInTime": "On-schedule, %",
         "plannedDepartureTime": "Route start time, hrs (planned)",
         "plannedArrivalTime": "Route end time, hrs (planned)",
         "plannedDuration": "Route duration, hrs (planned)",
         "factDuration": "Route duration, hrs (actual)",
         "duration": "Route duration",
         "plannedPoints": "Number of stops (planned)",
         "points": "Number of stops",
         "skippedPoints": "Missed stops",
         "skippedCircles": "Missed trips"
     },
     "mapLabels": {
         "maps": "Maps",
         "geoZones": "Geozones",
         "trackAdvanced": "Vehicle track",
         "autoTracking": "Auto tracking",
         "autoTrackingGroup": "Group auto tracking",
         "autoTrackingObject": "Vehicle auto tracking",
         "trackAdvancedGroup": "Group vehicle track",
         "areaSearch": "Area search",
         "sectionMap": "Map",
         "back": "Back",
         "areaSearchDescription": "Which vehicles were in a drawn area",
         "geoZonesDescription": "View and edit geozones",
         "trackAdvancedDescription": "One vehicle route for a period",
         "autoTrackingDescription": "Follow a vehicle live",
         "trackAdvancedGroupDescription": "Several vehicle routes for a period",
         "autoTrackingGroupDescription": "Follow a vehicle group live"
     },
     "geoGroups": {
         "name": "Geo groups"
     },
     "trackAdvanced": {
         "details": "Detailed information",
         "detailsTrack": "Track details",
         "fullDataTrack": "Track",
         "detailsToggleButton": "Show/Hide additional information",
         "totalTrackDistanceInKilometres": "Total distance",
         "motionStatusCodeDescription": "Status",
         "satelliteCount": "Satellites",
         "satelliteCountShort": "Sat.",
         "advancedTimeIndex": "#",
         "deviceLastInfo": "Last data",
         "deviceCurrentInfo": "Current data",
         "changeMapViewOnAdvancedIndex": "Move map to vehicle",
         "changeMapViewOnAdvancedIndexHelper": "Move map to vehicle when changing position (if vehicle status window is closed)",
         "showLastInfoDuringTrack": "Show vehicle info during track",
         "skipFilters": "Show points without GPS fix",
         "skipFiltersHelper": "Technical mode: shows every point from the tracker, including those with no coordinates (0,0). The track on the map will jump — use it to verify the connection and sensor data.",
         "stops": "Stops",
         "stopsVisited": "Visited stops",
         "showPointVisited": "Visited route points (stops)",
         "showGeoZoneVisited": "Visited geozones",
         "geoZoneVisited": "Visited geozones",
         "geoZonesVisited": "Geozone visits",
         "trackFirstFuelLevel": "Initial fuel level",
         "trackMinFuelLevel": "Minimum fuel level",
         "trackMaxFuelLevel": "Maximum fuel level",
         "firstMotionTime": "Track start date",
         "lastMotionTime": "Track end date",
         "baseInfoTrack": "General information",
         "totalMovingDurationInMinutes": "Total moving duration in minutes",
         "totalStoppedDurationInMinutes": "Total stopped duration in minutes",
         "totalMovingDuration": "Total moving duration",
         "totalStoppedDuration": "Total stopped duration",
         "selectField": "Select fields to display",
         "chartTrack": "Charts",
         "showFieldsRowData": "Show raw data fields"
     },
     "autoTracking": {
         "deviceCurrentInfo": "Current data",
         "fullDataTrack": "Track",
         "pausedTracking": "Pause tracking",
         "showVoyageShape": "Show order",
         "changeMapViewOnLastInfo": "Move map to vehicle when changing position (if vehicle status window is closed)"
     },
     "deviceOperationStatistic": {
         "name": "Operational statistics",
         "agencyName": "Carrier",
         "sumVoyageSchedule": "By schedules",
         "sumAllVoyagePlanned": "Total",
         "sumVoyageInRoute": "On route",
         "sumVoyageNotInRoute": "Off route",
         "sumVoyageGpsFailed": "Not transmitting signal",
         "sumVoyageNotScheduled": "Not scheduled",
         "routeDescription": "Route",
         "licensePlate": "License plate",
         "ordinal": "Route",
         "scheduleId": "Order",
         "status": "Status",
         "filtersStatusesVoyage": "Route status filters",
         "filtersData": "Data filters",
         "withoutStatusFilters": "Without filter",
         "rootFilters": "Basic filters",
         "statuses": {
             "inRoute": "On route",
             "gpsError": "Not transmitting gps",
             "notInRoute": "Off route",
             "notPlanned": "Not planned",
             "green": "Connected within 15 minutes",
             "yellow": "Connected 15 minutes to 1 hour ago",
             "red": "Not connected for more than an hour"
         },
         "filterStatuses": {
             "statusVoyagesGood": "All parameters are good",
             "statusVoyagesAverage": "Average (Rows with at least 1 yellow element)",
             "statusVoyagesPoor": "Poor (Rows with at least 1 red element)",
             "statusAfpsDeviceAverage": "Average driver validators (Rows with at least 1 yellow element)",
             "statusAfpsDevicePoor": "Poor driver validators (Rows with at least 1 red element)",
             "statusAfpsSelfServiceAverage": "Average self-service validators (Rows with at least 1 yellow element)",
             "statusAfpsSelfServicePoor": "Poor self-service validators (Rows with at least 1 red element)",
             "sumAllVoyagePlannedGood": "Total (good)",
             "sumVoyageInRouteGood": "On route (good)",
             "sumVoyageNotInRouteGood": "Off route (good)",
             "sumVoyageGpsFailedGood": "Not transmitting signal (good)",
             "sumVoyageNotScheduledGood": "Not scheduled (good)",
             "sumAllVoyagePlannedAverage": "Total (average)",
             "sumVoyageInRouteAverage": "On route (average)",
             "sumVoyageNotInRouteAverage": "Off route (average)",
             "sumVoyageGpsFailedAverage": "Not transmitting signal (average)",
             "sumVoyageNotScheduledAverage": "Not scheduled (average)",
             "sumAllVoyagePlannedPoor": "Total (poor)",
             "sumVoyageInRoutePoor": "On route (poor)",
             "sumVoyageNotInRoutePoor": "Off route (poor)",
             "sumVoyageGpsFailedPoor": "Not transmitting signal (poor)",
             "sumVoyageNotScheduledPoor": "Not scheduled (poor)"
         },
         "sumVoyageGpsSuccess": "Sending signal",
         "byDevices": "Planned operational statistics (by vehicle)",
         "lastEventTime": "Last data time",
         "dateWithoutSignal": "Period without signal"
     },
     "adminAccounts": {
         "navigate": "System (new)",
         "title": "System accounts",
         "searchPlaceholder": "Search by account id, description, organisation or #id",
         "code": "Account id",
         "description": "Account description",
         "labelName": "Organisation name",
         "state": "Active",
         "yes": "Yes",
         "no": "No",
         "maximumDevicesAvailable": "Trackers available",
         "activeDevices": "Active",
         "maximumDevices": "Maximum number of devices (trackers)",
         "maximumDevicesShort": "Tracker limit",
         "unlimited": "\"0\" - unlimited",
         "deviceCount": "Number of trackers",
         "inactiveDeviceCount": "Contract expired",
         "createdAt": "Created",
         "lastLoginAt": "Last sign in",
         "online": "Online",
         "stateYES": "Active",
         "stateNO": "Inactive",
         "stateTENANT": "System admin account",
         "stateEXTENDED": "Multi account",
         "summaryTotal": "Accounts",
         "summaryDevices": "Active trackers / total",
         "filterActive": "Active",
         "filterInactive": "Inactive",
         "filterMulti": "Multi accounts",
         "filterOnline": "Online now",
         "onlineTooltip": "Admin: {{admins}}, users: {{users}}",
         "never": "Never",
         "today": "Today",
         "yesterday": "Yesterday",
         "daysAgo": "{{count}} d ago",
         "monthsAgo": "{{count}} mo ago",
         "yearsAgo": "{{count}} y ago",
         "connect": "Connect",
         "connectInactive": "The account is inactive, connecting to it is not possible",
         "connectConfirmTitle": "Connect to the account?",
         "connectConfirmText": "You will enter {{code}} as its account admin. The account button in the header takes you back or to another account.",
         "connectInactiveText": "Activate the account on its edit page first.",
         "connectUserConfirmTitle": "Connect as this user?",
         "connectUserConfirmText": "You will enter {{code}} as {{login}} and see the system the way they do. The account button in the header takes you back or to another account.",
         "edit": "Edit",
         "back": "System accounts",
         "release": "Back to {{account}}",
         "switcherTitle": "Switch account",
         "switcherTooltip": "Switch account",
         "switcherConnectedTooltip": "You are in {{code}}, connected as {{user}}. Click to switch account",
         "switcherYouAreIn": "You are in your own account {{code}}",
         "switcherConnectedAs": "You are in {{code}}, connected as {{user}}",
         "switcherSearch": "Search an account by code or description",
         "switcherOwn": "My account",
         "switcherCurrent": "Current",
         "switcherMulti": "Multi",
         "switcherNothing": "Nothing found",
         "switcherConfirm": "Switch to {{code}} as its account admin?",
         "switcherConfirmUser": "Switch to {{code}} as {{login}}?",
         "switcherGo": "Switch",
         "switcherFavorites": "Favourites",
         "switcherAll": "All accounts",
         "switcherFavorite": "Add to favourites",
         "switcherUnfavorite": "Remove from favourites",
         "switcherFavoritesHint": "Star the accounts you open most often: they stay at the top of the list.",
         "switcherAsUser": "Connect as a user",
         "switcherUsersTitle": "Connect to {{code}} as…",
         "switcherUsersSearch": "Search a user by login or name",
         "switcherAsAdmin": "Account admin",
         "switcherNoUsers": "The account has no users",
         "switcherBack": "Back to the accounts",
         "switcherFilter": {
             "all": "All",
             "active": "Active",
             "multi": "Multi",
             "inactive": "Inactive"
         },
         "dateCreating": "Created",
         "dateOfLastEntry": "Last sign in",
         "cardMain": "Account",
         "cardAdmin": "Account admin",
         "cardModules": "Module access",
         "cardMultiAccounts": "Multi accounts",
         "cardServices": "Servers",
         "active": "Active",
         "activeHint": "An inactive account cannot sign in",
         "notes": "General remarks",
         "contactName": "Account admin",
         "contactEmail": "Admin email",
         "contactPhone": "Admin phone",
         "invalidEmail": "Invalid email",
         "visibleFuelInfo": "Show fuel information",
         "visibleSingleVoyage": "Access to the \"Single voyage\" module",
         "visibleStaffSchedule": "Access to the \"Staff schedule\" module",
         "multiAccountIds": "Give multi accounts access to single voyages",
         "shareDefaultGroup": "Give linked multi accounts the location of every vehicle on the map",
         "shareDefaultGroupHint": "Share the standard \"All\" group with the linked multi accounts",
         "shareToMultiAccountIds": "Multi accounts that see every vehicle",
         "multiAccountNoShare": "A multi account does not share its \"All\" group",
         "addressGeocodingServer": "Geocoding server address",
         "apiKeyGeocodingServer": "Geocoding server API key",
         "addressRoutingServer": "Routing server address",
         "apiKeyRoutingServer": "Routing server API key",
         "addressTransitPredictionServer": "Movement prediction server URL",
         "apiKeyTransitPredictionServer": "Movement prediction server API key",
         "multiAccount": "Sign of multi account",
         "multiAccountHint": "A multi account sees the devices of other accounts; an account with its own devices cannot be one",
         "tenantAdmin": "Sysadmin account",
         "tenantAdminHint": "for the tenant account: creates a tenant of its own",
         "tenantAdminSet": "The account already administers a tenant; this page does not undo it",
         "adminPassword": "Admin password",
         "adminPasswordHint": "Leave empty to keep it.",
         "passwordChangedAt": "Changed {{date}}.",
         "geocoderMode": "Geocoding coordinates (reverse)",
         "geocoderModeGEOZONE": "Geozone",
         "geocoderModeFULL": "Full (external server)",
         "geocoderProvider": "Geocoding addresses (forward)",
         "smsProperties": "SMS",
         "create": "New account",
         "createTitle": "New account",
         "createText": "The account gets the All group and joins the tenant. Set the rest on its edit page.",
         "createCode": "Account id",
         "createCodeHint": "Latin letters, digits, @ . _ -",
         "created": "Account registered successfully",
         "legacyNote": "Tariff, admin password and corporate styles are changed on the legacy account page",
         "openLegacy": "Legacy page",
         "unsaved": "There are unsaved changes",
         "saved": "All changes saved",
         "cancel": "Cancel",
         "save": "Save",
         "noAccess": "The page is available to the tenant administrator",
         "notFound": "Account not found"
     },
     "adminSystem": {
         "tabAccounts": "Accounts",
         "tabUsers": "Users",
         "tabDevices": "Objects",
         "tabEmployees": "Employees",
         "tabUnregistered": "Unregistered",
         "tabUsersTitle": "Server users",
         "tabDevicesTitle": "Server objects",
         "tabEmployeesTitle": "Server employees",
         "tabUnregisteredTitle": "Unregistered objects",
         "filterAll": "All",
         "filterActive": "Active",
         "filterInactive": "Inactive",
         "export": "Export",
         "exportTooltip": "CSV of every record matching the search and the filter",
         "account": "Account",
         "back": "Back",
         "resetView": "Reset view",
         "resetViewTooltip": "Back to the default column widths, visible columns, row height and sort",
         "accountInactive": "The account is inactive",
         "status": "Status",
         "active": "Active",
         "inactive": "Inactive",
         "createdAt": "Date of creation",
         "editAccount": "Edit the account",
         "connectToAccount": "Connect to the account",
         "connectAsUser": "Connect as {{login}}",
         "openAccountLegacy": "Legacy account page",
         "editUser": "Edit user",
         "openUserLegacy": "Legacy user page",
         "editDevice": "Edit object",
         "openDeviceLegacy": "Legacy object page",
         "editEmployee": "Edit employee",
         "usersSearch": "Search by account, login, full name or e-mail",
         "userLogin": "User login",
         "userName": "Full name",
         "userEmail": "E-mail",
         "userRole": "Role",
         "userDescription": "User status",
         "userTimeZone": "Time zone",
         "userLastLogin": "Last logon",
         "userOnline": "Signed in now: {{count}}",
         "devicesSearch": "Search by account, object id, description, brand, license plate, IMEI or phone",
         "deviceCode": "Id. object",
         "deviceDescription": "Description",
         "deviceBrand": "Brand",
         "deviceLicensePlate": "License plate",
         "deviceClass": "Class",
         "deviceColor": "Color",
         "devicePhone": "Phone number of the instrument",
         "deviceActiveUntil": "Active till",
         "deviceLastEvent": "Last data",
         "employeesSearch": "Search by account, name, personnel number, badge, phone or e-mail",
         "employeeName": "Name of contact",
         "employeePersonnelNumber": "Personnel number",
         "employeeStatus": "Title",
         "employeeBadge": "Badge",
         "employeeCodeword": "Codeword",
         "employeePhone": "Phone number",
         "employeeEmail": "E-mail",
         "employeeActiveUntil": "Active till",
         "employeeStatusDRIVER": "Driver",
         "employeeStatusCONDUCTOR": "Conductor",
         "employeeStatusRESPONSIBLE": "Responsible",
         "employeeStatusMECHANIC": "Mechanic",
         "employeeStatusDOCTOR": "Doctor",
         "employeeStatusMANAGER": "Manager",
         "employeeStatusSINGLE_VOYAGE_DRIVER": "Single voyage driver",
         "employeeStatusPEDESTRIAN": "Pedestrian",
         "unregisteredSearch": "Search by IMEI or IP",
         "unregisteredPort": "Port",
         "unregisteredFirstConnect": "First connection",
         "unregisteredLastConnect": "Last connection",
         "unregisteredConnections": "Number of connections",
         "unregisteredDelete": "Remove ({{count}})",
         "unregisteredClear": "Clear list",
         "unregisteredDeleteTitle": "Remove the selected objects from the list?",
         "unregisteredClearTitle": "Clear the list of unregistered objects?",
         "unregisteredDeleteText": "A tracker comes back to the list the next time it connects to the server.",
         "unregisteredDeleted": "Removed from the list: {{count}}",
         "confirmDelete": "Remove",
         "cancel": "Cancel",
         "employeeNew": "New employee",
         "employeeNewHint": "Employee record",
         "employeeCreate": "Register",
         "employeeNotFound": "Employee not found",
         "employeeCardMain": "Employee",
         "employeeCardDocuments": "Documents",
         "employeeCardPhoto": "Photo",
         "employeeCardAccess": "Access",
         "employeeCardMobile": "Mobile app",
         "employeeFullName": "Contact (full name)",
         "employeeShortName": "Short name",
         "employeeStatusLabel": "Employee status",
         "employeeBadgeFull": "Personal badge or ID code",
         "employeeBadgeHint": "Code of the personal i-Button or RFID tag",
         "employeePhoneInvalid": "9 to 15 digits, a leading + allowed",
         "employeeEmailInvalid": "Invalid e-mail",
         "employeeBirthDate": "Date of birth",
         "employeeCodewordHint": "A word to identify the person by phone",
         "employeeAddress": "Home address",
         "employeeNotes": "Notes",
         "employeeDriverClass": "Driver class / driving experience",
         "employeeLicenseType": "Driving licence category",
         "employeeLicenseNumber": "Driving licence number",
         "employeeLicenseStart": "Licence issued",
         "employeeLicenseExpire": "Licence valid until",
         "employeePassport": "Passport number",
         "employeeWorkStart": "Hired on",
         "employeeOrder": "Order No.",
         "employeeOrderHint": "Hiring order No.",
         "employeePhotoSelect": "Choose an image",
         "employeePhotoHint": "JPEG or PNG up to 512 KB",
         "employeeGroups": "Assign to groups",
         "employeeWorksession": "Shift assignment",
         "employeeWorksessionMANUAL": "Manual",
         "employeeWorksessionVOYAGE": "Voyage",
         "employeeWorksessionRFID": "RFID",
         "employeeConsolePassword": "Console password",
         "employeeConsolePasswordHint": "Password of the driver console",
         "employeeMobileActive": "Mobile app access",
         "employeeMobileActiveHint": "Turns on tracking the person by phone",
         "employeeMobileOnlyPedestrian": "The mobile app is available to an employee with the Pedestrian status.",
         "employeeLogin": "Login",
         "employeePassword": "Password",
         "employeePasswordNewHint": "At least 8 characters",
         "employeePasswordHint": "Leave empty to keep it",
         "employeeDeactivate": "Deactivate",
         "employeeDeactivateTitle": "Deactivate the employee?",
         "employeeDeactivateText": "The record stays inactive: voyages and reports still point at it. Its mobile device is turned off.",
         "employeeDeactivated": "Employee deactivated",
         "unitKmh": "km/h",
         "unitSec": "s",
         "unitM": "m",
         "unitKm": "km",
         "unitHours": "h",
         "unitMin": "min",
         "unitDays": "days",
         "setting": {
             "filterData": "Filter the position data in messages",
             "trackModeFix": "Track mode",
             "trackModeFix_DEVICE_TIME": "By device time",
             "trackModeFix_SERVER_TIME": "By server time",
             "filterInvalid": "Skip invalid messages",
             "filterMinSatellites": "Minimum satellites",
             "filterMaxHDOP": "Maximum HDOP",
             "filterMaxSpeed": "Maximum speed",
             "tripMethodOfMoving": "Movement detection",
             "tripMethodOfMoving_GPS_SPEED": "GPS speed",
             "tripMethodOfMoving_GPS_POSITION": "GPS position",
             "tripMethodOfMoving_IGNITION_SENSOR": "Ignition sensor",
             "tripMethodOfMoving_ODOMETER_SENSOR": "Odometer sensor",
             "tripMethodOfMoving_RELATIVE_SENSOR": "Relative odometer",
             "tripMethodOfMoving_ACSELEROMETER": "Accelerometer",
             "movingMinSpeed": "Minimum moving speed",
             "movingMaxStopDuration": "Minimum parking time",
             "movingGPScorrOn": "GPS correction",
             "movingMinSatellites": "Minimum satellites",
             "movingMinDistance": "Minimum moving distance",
             "movingMaxDistanceBetweenMessages": "Maximum distance between messages",
             "tripMinDuration": "Minimum trip time",
             "tripMinDistance": "Minimum trip distance",
             "filterBypassOnParking": "Ignore the speed filter when leaving a parking",
             "speedLimitKPH": "Speed limit",
             "rptLimitSpeedCity": "City speed limit",
             "rptDayEngineHR": "Daily engine hours norm",
             "rptFactorDist": "Mileage factor",
             "turboTimer": "Turbo timer",
             "rptTurboToArmed": "Delay of the Armed state",
             "odomCountingType": "Mileage odometer",
             "odomCountingType_GPS": "GPS",
             "odomCountingType_GPS_AND_ACCELEROMETER": "GPS + accelerometer",
             "odomCountingType_GPS_AND_IGNITION": "GPS + ignition",
             "odomCountingType_ABSOLUTE_ODOMETER": "GPS + absolute odometer",
             "odomCountingType_RELATIVE_ODOMETER": "GPS + relative odometer",
             "lastGPSOdomKM": "Mileage odometer value",
             "vehicleCountingType": "Engine hours odometer",
             "vehicleCountingType_IGNITION": "Ignition sensor",
             "vehicleCountingType_ABSOLUTE_HOURS": "Absolute engine hours sensor",
             "vehicleCountingType_RELATIVE_HOURS": "Relative engine hours sensor",
             "lastEngineHours": "Engine hours value",
             "countGprsTraffic": "GPRS traffic odometer",
             "countDays": "Daily odometer",
             "countNotes": "Notes",
             "accessCode": "Device access code",
             "controlNotes": "Notes",
             "filterDataHint": "Invalid messages (outliers, no coordinates) are not counted in mileage and reports.",
             "filterInvalidHint": "A message flagged as invalid is not used for the track, but its sensors are counted.",
             "filterMinSatellitesHint": "Recommended value: at least three.",
             "filterMaxHDOPHint": "The lower the value, the more precise the coordinates.",
             "filterMaxSpeedHint": "Messages with a higher speed are marked as invalid.",
             "movingMinSpeedHint": "The minimum speed treated as the start of movement.",
             "movingMaxStopDurationHint": "How long the object has to stand for it to be parking rather than a stop. At least 10 s.",
             "movingGPScorrOnHint": "Useful for all detection methods, especially the ignition sensor; better turned off for the odometer.",
             "movingMinSatellitesHint": "The minimum number of satellites at which data is valid.",
             "movingMinDistanceHint": "How far the object has to move for it to be the start of movement.",
             "movingMaxDistanceBetweenMessagesHint": "Beyond this distance a movement interval ends and a new one begins. At least 50 m.",
             "tripMinDurationHint": "How long the object has to move for it to be a trip.",
             "tripMinDistanceHint": "How far the object has to travel for it to be a trip.",
             "filterBypassOnParkingHint": "Skips the inflated speed of the first message after parking, keeping the real mileage.",
             "speedLimitKPHHint": "The maximum allowed speed for this object.",
             "rptLimitSpeedCityHint": "Up to this speed movement counts as urban, above it as suburban.",
             "rptDayEngineHRHint": "Used in the engine hours report.",
             "rptFactorDistHint": "To compare the detected mileage with the speedometer mileage.",
             "lastGPSOdomKMHint": "Changing the reading overwrites the object's odometer.",
             "accessCodeHint": "Access password of the object for remote control (if required)."
         },
         "deviceNew": "New object",
         "deviceNewHint": "The object starts inactive in the All group of the account. Fill it in on its page.",
         "deviceCreated": "Object created",
         "deviceMoved": "Object moved to {{code}}",
         "deviceNotFound": "Object not found",
         "deviceMove": "Move",
         "deviceMoveTitle": "Move {{code}} to another account?",
         "deviceMoveText": "The object leaves its groups and joins the All group of the chosen account with its sensors and calibrations. Save the changes before moving.",
         "deviceTabMain": "Main",
         "deviceTabFilter": "Filters",
         "deviceTabTrip": "Movement detector",
         "deviceTabReport": "Report data",
         "deviceTabCounter": "Odometers",
         "deviceTabFuel": "Fuel",
         "deviceTabSensor": "Sensors",
         "deviceTabEmployee": "Employees",
         "deviceTabService": "Maintenance",
         "deviceTabControl": "Control",
         "deviceTabField": "Custom fields",
         "deviceTabStyle": "Styles",
         "deviceCardMain": "Main object data",
         "deviceCardStaff": "Staff customers / staff schedule",
         "deviceCardTracker": "Tracker",
         "deviceCardServer": "Server",
         "deviceInactiveHint": "An inactive object leaves every group",
         "deviceCodeFull": "Object id in the account",
         "deviceCodeHint": "Unique within the account. Latin letters, no spaces.",
         "deviceDescriptionFull": "Object description",
         "deviceRequired": "Required",
         "deviceLicensePlateFull": "License plate",
         "deviceLicensePlateHint": "Latin letters only; Cyrillic is replaced automatically.",
         "deviceBrandFull": "Brand",
         "deviceClassFull": "Object class",
         "deviceClassHint": "Truck, bus, van, car …",
         "deviceVehicleId": "Technical passport (ID) No.",
         "deviceActiveUntilFull": "Active until",
         "devicePassengers": "Passenger capacity",
         "deviceManufactureDate": "Manufacture date",
         "deviceClassiness": "Classiness",
         "deviceComposition": "Composition",
         "deviceHandicapped": "Low floor",
         "deviceRecordEvent": "Keep the movement history (track)",
         "deviceNotes": "Notes",
         "deviceStaffCustomer": "Staff customers",
         "deviceStaffAssignment": "Staff assignment",
         "deviceGroups": "Assign to groups",
         "deviceGroupsInactive": "An inactive object is in no group",
         "deviceImei": "IMEI or ESN",
         "deviceImeiHint": "Unique on the server",
         "deviceSerial": "Tracker serial number",
         "deviceMainSim": "Main SIM phone number",
         "deviceAdditionalSim": "Additional SIM phone number",
         "deviceLeasedSim": "Leased",
         "deviceSmsEmail": "E-mail to send SMS",
         "deviceMobileData": "Mobile data sending",
         "deviceMobileDataMinutes": "Mobile data starts after, min",
         "deviceWorkOrder": "Work order",
         "deviceUniqueId": "Server unique id",
         "deviceProtocol": "Server type",
         "deviceProtocolVersion": "Firmware version",
         "userNew": "New user",
         "userNewHint": "Choose the account, the login and the password. Set the rest on the user page.",
         "userLoginHint": "Unique within the account. Latin letters, no spaces.",
         "userPassword": "Password",
         "userCreated": "User successfully registered",
         "userDeleted": "User removed successfully",
         "userNotFound": "User not found",
         "userDeleteTitle": "Delete user {{login}}?",
         "userDeleteText": "A user who created routes, schedules or geozones cannot be deleted; deactivate them instead.",
         "usersDeleteInactive": "Delete inactive",
         "usersDeleteInactiveTitle": "Delete the inactive users of the tenant?",
         "usersDeleteInactiveText": "Those who created routes, schedules or geozones stay.",
         "usersInactiveDeleted": "Inactive users deleted. Deleted: {{count}}",
         "userTabMain": "Main",
         "userTabTooltip": "Tooltip",
         "userTabMap": "Objects on the map",
         "userTabFields": "Custom fields",
         "userCardMain": "User data",
         "userCardAccess": "Rights",
         "userCardPreferences": "Preferences",
         "userContact": "Contact",
         "userEmailFull": "User e-mail",
         "userPhone": "User phone",
         "userNotifyEmail": "E-mail for notifications",
         "userGroup": "Authorized for the group",
         "userGroupAll": "All",
         "userStaffAccessSet": "Access is set by the staff schedule",
         "userStaffAccessNote": "The staff schedule access is changed on the legacy user page.",
         "userAllowExport": "Allow export",
         "userSpecRegime": "Allow the special mode",
         "userSpecRegimeHint": "Whether the user may put a vehicle into the special mode on the stadium",
         "userDriverMovement": "Access to the \"Driver movement regularity\" report",
         "userDriverMovementHint": "Whether the user may build the \"Driver movement regularity\" report",
         "userStartPage": "Start page",
         "userDefaultMap": "Default map",
         "userChatNotifications": "Chat message notifications (sound and pop-ups)",
         "userPhotoRemove": "Remove",
         "userTooltipTitle": "What the tooltip of an object shows",
         "userMapTitle": "How objects are shown on the map",
         "userMapDriverName": "Replace object names with driver names",
         "userMapDriverNameHint": "Objects on the map show the names of their drivers, when assigned.",
         "userMapGroup": "Group overlapping object icons",
         "userMapGroupHint": "Objects whose icons overlap are shown as one icon.",
         "userMapPath": "Trail behind the object",
         "userMapPathHint": "Length of the trail behind an object, in messages.",
         "userFieldsTitle": "Custom fields",
         "userFieldTitle": "Name",
         "userFieldValue": "Value",
         "userFieldAdd": "Add a field",
         "startPage": {
             "menu_top": "Desktop",
             "map_object": "Object on the map",
             "map_group": "Group on the map",
             "driver_info": "Drivers",
             "fuel_info": "Fuel",
             "voyage_info": "Voyage",
             "report_info": "Reports"
         },
         "map": {
             "osm": "OpenStreetMap Default",
             "trav": "MicroGIS",
             "visicom": "Visicom",
             "osmMapQuest": "OpenStreetMap MapQuest",
             "gTer": "Google Physical",
             "gRoad": "Google Streets",
             "gSat": "Google Satellite",
             "gHyb": "Google Hybrid",
             "yndx": "Yandex Maps",
             "ysat": "Yandex Satellite",
             "yhyb": "Yandex Hybryd",
             "ypub": "Yandex Public",
             "ypubhyb": "Yandex Public Hybrid"
         },
         "tooltip": {
             "info": "Object info",
             "lastDate": "Last data",
             "brand": "Brand",
             "description": "Object description",
             "licensePlate": "License plate",
             "group": "Group",
             "account": "Account",
             "showClass": "Class",
             "fuelInTank": "Fuel",
             "staffCustomer": "Staff customers",
             "staffAssignment": "Staff assignment",
             "parkingTown": "Parking town",
             "parkingAddress": "Parking address",
             "position": "Position",
             "speed": "Speed",
             "height": "Altitude",
             "satellite": "Satellites",
             "counter": "Odometers",
             "geozonePresence": "Geozone presence",
             "option": "Parameters",
             "sensorValue": "Sensor values",
             "task": "Tasks",
             "driver": "Driver",
             "maintenance": "Maintenance",
             "customFields": "Custom fields",
             "infoHint": "Device type, unique ID and phone number set in the object properties.",
             "lastDateHint": "Date of the last message.",
             "brandHint": "Object make.",
             "groupHint": "Object group.",
             "accountHint": "Object account.",
             "showClassHint": "Object class.",
             "fuelInTankHint": "Fuel level in the tank.",
             "positionHint": "The last detected address of the object's location.",
             "speedHint": "Speed given in the last message.",
             "heightHint": "Altitude above sea level (if the device sends it).",
             "satelliteHint": "Number of satellites locked in the last message.",
             "counterHint": "Mileage odometer and engine hours readings.",
             "geozonePresenceHint": "The geozone the object was in at the last message, in its colour.",
             "optionHint": "All parameters given in the last message, without conversion.",
             "sensorValueHint": "Sensors and their values, that is, interpreted parameter values.",
             "taskHint": "Assigned tasks and their current state.",
             "driverHint": "Name, photo (if set) and phone of the driver currently driving the object.",
             "maintenanceHint": "Set service intervals and their due dates.",
             "customFieldsHint": "Custom fields from the object properties with their values."
         }
     },
     "equipment": {
         "connected": "Connected",
         "registry": "Registry",
         "instruction": "Instruction",
         "routerSetup": "Router setup",
         "addMikrotik": "Add MikroTik"
     },
     "dashboardPage": {
         "greetingMorning": "Good morning,",
         "greetingDay": "Good afternoon,",
         "greetingEvening": "Good evening,",
         "withUs": "with us {{duration}}",
         "accountSince": "account since {{date}}",
         "balance": "Balance",
         "balanceOf": "of {{value}} top-up",
         "devicesOnline": "Vehicles online",
         "onlineShare": "{{percent}}% of the fleet connected",
         "voyagesOnRoute": "Voyages on route",
         "voyagesProblems": "{{notInRoute}} off route · {{gps}} GPS failures",
         "activity": "Device activity",
         "total": "{{value}} in total",
         "online": "online",
         "activityHint": "Click a sector, bar or legend row to see the vehicles",
         "donut": "Donut",
         "bars": "Bars",
         "short": {
             "totalOnline": "Online",
             "totalOneHour": "< 1 h",
             "totalLastDay": "< day",
             "totalLastWeek": "< week",
             "totalLastMonth": "< month",
             "totalBeforeLastMonth": "> month",
             "totalNotConnected": "Never",
             "totalInactive": "Off"
         },
         "news": "News",
         "sessions": "Account logins",
         "user": "User",
         "loginAt": "Login",
         "session": "Session",
         "ip": "IP",
         "today": "today",
         "yesterday": "yesterday",
         "settings": "My settings",
         "timeZone": "Time zone",
         "startPage": "Start page",
         "save": "Save",
         "saved": "Settings saved",
         "saveError": "Could not save the settings",
         "search": "Search",
         "empty": "No records"
     },
     "minNumber0": "The value cannot be less than 0",
     "minNumber1": "The value cannot be less than 1",
     "minLengthElem1": "At least 1 item is required",
     "edit": "Editing",
     "voyagePlanning": {
         "voyageStatuses": {
             "COMPLETED_IN_TIME": "Completed on time",
             "COMPLETED_AHEAD": "Completed early",
             "COMPLETED_LATENESS": "Completed late",
             "EXPIRED": "Expired",
             "INTERRUPTED": "Interrupted",
             "RUN": "On voyage",
             "RUN_AHEAD": "On voyage, ahead",
             "RUN_LATENESS": "On voyage, late",
             "RUN_WITH_DEFLECTION": "On voyage (deflection)",
             "CREATED": "Newly assigned",
             "REGISTERED": "Registered",
             "DRAFTED": "Left the route",
             "IDLE": "Idle"
         },
         "releaseNumbers": "Release numbers",
         "saveMode": "Save mode",
         "finishedVoyages": {
             "title": "Earlier on this release:",
             "markerFinished": "{{plate}}, interrupted at {{time}}",
             "markerReplaced": "Swap at {{time}}: {{from}} → {{to}}",
             "itemFinished": "{{plate}}, {{driver}}: finished at {{time}}",
             "itemReplaced": "Swap at {{time}}: {{from}} → {{to}}",
             "by": "({{name}})",
             "noDriver": "no driver",
             "assignSame": "Assign the same vehicle"
         },
         "list": {
             "notAssigned": "Not assigned",
             "noDriver": "No driver assigned",
             "empty": "Nothing found"
         },
         "hints": {
             "localSave": "As in the old planning: changes collect as a draft and reach the system only after «Save changes».",
             "serverSave": "Each change in the voyage window is saved to the system at once. The duty roster for several days ahead can also be filled here.",
             "change": "Show the plan for the selected carrier and dates.",
             "refresh": "Load the plan again to see changes by other dispatchers.",
             "saveChanges": "Send all your changes to the system at once, without review.",
             "checkAndSave": "First show the list of what will be added, changed or deleted. You can save after reviewing it.",
             "clearLocalSlots": "Discard all unsaved changes. The plan returns to what is already in the system.",
             "voyageLetter": "Open the waybills PDF in a new tab: for the selected route or for all shown.",
             "dayOutfit": "Open the daily duty roster PDF in a new tab: for the selected route or for all shown.",
             "driverSchedule": "Download a PDF with the stop schedule of every release, for drivers.",
             "releaseNumbers": "Show the release number in the table cells."
         }
     }
 };
